<template>
  <div class="selectbox" @click="select">
    <div class="text">筛选</div>
    <div class="selectbox-text">{{ value }}</div>
    <div class="weui-cell__ft">
      <span v-show="!value">请选择</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
  },
  methods: {
    select() {
      var me = this,
        defaultText = 'detail',
        arrary = [
          { value: "detail", label: "全部" },
          { value: "proj", label: "项目" },
          { value: "dept", label: "部门" },
          { value: "empl", label: "人员" },
        ];
      me.$weui.picker(arrary,{
        title: "筛选条件",
        defaultValue: [defaultText],
        onConfirm: function (r) {
          me.period = r[0].label;
          me.$emit("input", me.period);
          me.$emit("change", me.period);
        },
      });
    },
  },
};
</script>
<style scoped>
.selectbox {
  display: flex;
  flex-direction: row;
  padding: 20px 4px 20px 10px;
  /* border-right:0px dashed #ccc ; */
}
.text{
  font-size: 12px;
  color: #9b9b9b;
}
.selectbox-text {
  font-size: 12px;
  color: #333;
  margin-left:10px ;
}
</style>




<!-- 
<template>
  <picker-field
    :label="label"
    :display="display"
    :value="value"
    ref="picker"
    @open="onSearch"
  >
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item.text }}</p>
          </div>
          
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "全部",
    },
    value: String,
  },
  data() {
    return {
      display: null,
      items: [
        {
          id: 1,
          value: "detail",
          text: "全部",
        },
        {
          id: 2,
          value: "prod",
          text: "产品",
        },
        {
          id: 3,
          value: "cust",
          text: "客户",
        },
        {
          id: 4,
          value: "custtype",
          text: "客户类型",
        },
        {
          id: 5,
          value: "dept",
          text: "部门",
        },
        {
          id: 6,
          value: "seller",
          text: "业务员",
        },
      ],
    };
  },

  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.text);
      me.$emit("select", item);
      me.display = item.text;
      me.$refs.picker.close();
    },
  },
};
</script> -->
